import { Upload, Button, Tooltip } from "antd";
import { CheckCircleFilled, InfoCircleFilled, InfoCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { IFormUploadProps } from "./IFormComponents";

const FormUpload = (props: IFormUploadProps) => {
  const {
    label,
    translations,
    buttonText = translations?.uploadDocument,
    mandatory,
    oneRow,
    uploadedFile,
    disabled,
    error,
    isOcrLoading,
    handleBeforeUpload,
  } = props;

  return (
    <div className={`investor-form-item ${oneRow && "one-row"}`}>
      <label
        className={`${mandatory ? "mandatory" : ""} ${
          error ? "error-input" : ""
        } `}
      >
        {label} {" "}
		<Tooltip
		  title={translations?.uploadDocumentTooltip}
		>
		  <InfoCircleOutlined style={{ color: "#6b6b6bff" }} />
		</Tooltip>{" "}
      </label>
      <Upload
        beforeUpload={handleBeforeUpload}
        showUploadList={false}
        maxCount={1}
        accept=".pdf,.jpg,.png"
        disabled={disabled}
      >
        <Button
          disabled={disabled || isOcrLoading}
          loading={isOcrLoading}
          danger={error}
          style={{ width: "100%" }}
          icon={
            uploadedFile ? (
              <CheckCircleFilled style={{ color: "#B3D615" }} />
            ) : (
              <UploadOutlined />
            )
          }
        >
          {buttonText}
        </Button>
      </Upload>
    </div>
  );
};

export default FormUpload;
